import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { conversationAPI } from '../services/api';
import './ContactSupport.css';

const ContactSupport = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleContactSupport = async () => {
    setLoading(true);
    try {
      const response = await conversationAPI.contactSupport();
      navigate(`/chat/${response.data.id}`);
    } catch (err) {
      console.error('Failed to contact support:', err);
      alert('Unable to contact support. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-support-container">
      <div className="contact-support-content">
        <div className="support-icon">💬</div>
        <h1>Contact Support</h1>
        <p className="support-subtitle">
          Need help? Have questions? We're here for you!
        </p>

        <div className="support-reasons">
          <h3>We can help with:</h3>
          <ul>
            <li>✅ Payment verification and credit activation</li>
            <li>✅ Account issues and questions</li>
            <li>✅ Technical problems</li>
            <li>✅ Feature requests</li>
            <li>✅ General inquiries</li>
          </ul>
        </div>

        <button 
          className="btn-contact-support"
          onClick={handleContactSupport}
          disabled={loading}
        >
          {loading ? 'Opening chat...' : '💬 Message Support Team'}
        </button>

        <div className="support-info">
          <p>
            <strong>Response time:</strong> Usually within 1-2 hours during business hours
          </p>
          <p>
            <strong>Email:</strong> xtutorings@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactSupport;
